// align to backend schema
export enum NftType {
  Apostle = 'Apostle',
  Godiverse = 'Godiverse',
  Planet = 'Planet',
  Relic = 'Relic',
  Star = 'Star'
}
